var AlternativeQuestionChartComponent = /** @class */ (function () {
    function AlternativeQuestionChartComponent() {
        this.isLoading = true;
    }
    return AlternativeQuestionChartComponent;
}());
export { AlternativeQuestionChartComponent };
